import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import onClickOutside from "react-onclickoutside";
import { v4 as uuidv4 } from "uuid"; // random

// UI
import Button from "../button";
import HR from "../hr";
import P from "../paragraph";
import IconOk from "../icons/ok";
import IconTop from "../icons/arrowTop";
import IconDown from "../icons/arrowDown";

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listVisible: this.props.opened,
      title: this.props.title,
      selectedId: this.props.selectedId
    };

    this.toogleShow = this.toogleShow.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.setTitle = this.setTitle.bind(this);
    this.setSelect = this.setSelect.bind(this);
    this.setItem = this.setItem.bind(this);

    this.clearTitle = this.clearTitle.bind(this);
    this.clearSelect = this.clearSelect.bind(this);
    this.clearItem = this.clearItem.bind(this);

    this.handleSelect = this.handleSelect.bind(this);
    this.handleSelectAs = this.handleSelectAs.bind(this);
    this.renderSelectedIcon = this.renderSelectedIcon.bind(this);
    this.renderListItems = this.renderListItems.bind(this);
  }

  // Сохранение выбранного элемента
  componentDidMount() {
    // console.log("[Dropdown] ==> componentDidMount");

    let title = "";

    if (
      this.state.selectedId &&
      this.props.selectedId &&
      this.state.selectedId === this.props.selectedId
    ) {
      const idx = this.props.list.findIndex(
        itemList => itemList && itemList.id === this.props.selectedId
      );

      if (idx !== -1) {
        title = this.props.list[idx].title;
      }
    } else {
      if (this.props.type === "select" && this.props.required) {
        title = this.props.title || "Необходимо выбрать";
      } else {
        title = this.props.title || "Можно выбрать";
      }
    }

    this.setState({ title });
  }

  componentWillReceiveProps(nextProps) {
    // console.log("[Dropdown] ==> componentWillReceiveProps");

    // eslint-disable-next-line
    if (this.state.selectedId != nextProps.selectedId) {
      this.setState({ selectedId: nextProps.selectedId });
    }

    // eslint-disable-next-line
    if (
      this.state.selectedId !== nextProps.selectedId ||
      this.props.list.length !== nextProps.list.length
    ) {
      let title = this.props.title;

      // const idx1 = this.props.list.list.findIndex(itemList => itemList && itemList.id == nextProps.selectedId);
      // eslint-disable-next-line
      const idx = nextProps.list.findIndex(
        itemList => itemList && itemList.id === nextProps.selectedId
      );

      if (idx !== -1) {
        title = nextProps.list[idx].title;
      } else {
        if (this.props.type === "select" && this.props.required) {
          title = "Необходимо выбрать";
        }
      }

      this.setState({ title });
    }
  }

  // eslint-disable-next-line
  handleClickOutside = () => {
    if (this.state.listVisible) {
      // console.log("[Dropdown] ==> handleClickOutside");

      this.hide();
    }
  };

  handleSelect(item, func = () => {}) {
    // console.log("[Dropdown] ==> handleSelect");

    this.hide();

    if (item.clear) {
      this.clearItem();
    } else {
      if (item.clearTitle) {
        this.clearTitle();
      }

      if (item.clearSelect) {
        this.clearSelect();
      }
    }

    if (item.select) {
      this.setItem(item);
    } else {
      if (item.setTitle) {
        this.setTitle(item.title);
      }

      if (item.setSelect) {
        this.setSelect(item);
      }
    }

    func(item);
  }

  handleSelectAs(item, func = item => {}) {
    // console.log("[Dropdown] ==> handleSelectAs");

    this.hide();

    if (item.clear) {
      this.clearItem();
    } else {
      if (item.clearTitle) {
        this.clearTitle();
      }

      if (item.clearSelect) {
        this.clearSelect();
      }
    }

    if (item.select) {
      this.setItem(item);
    } else {
      if (item.setTitle) {
        this.setTitle(item.title);
      }

      if (item.setSelect) {
        this.setSelect(item);
      }
    }

    func(item);
  }

  toogleShow() {
    // console.log("[Dropdown] ==> toogleShow");

    if (this.state.listVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  setTitle(title) {
    // console.log("[Dropdown] ==> setTitle:", title);

    this.setState({ title });
  }

  setSelect(item) {
    // console.log("[Dropdown] ==> setSelect:", item.id);

    this.setState({ selectedId: item.id });
  }

  setItem(item) {
    // console.log("[Dropdown] ==> setItem");

    this.setTitle(item.title);
    this.setSelect(item);
  }

  clearTitle() {
    // console.log("[Dropdown] ==> clearTitle");

    this.setState({ title: this.props.title });
  }

  clearSelect() {
    // console.log("[Dropdown] ==> clearSelect");

    this.setState({ selectedId: null });
  }

  clearItem() {
    // console.log("[Dropdown] ==> clearItem");

    this.clearTitle();
    this.clearSelect();
  }

  show() {
    if (!this.props.noButton) {
      // console.log("[Dropdown] ==> show");

      this.setState({ listVisible: true });
    }
  }

  hide() {
    if (!this.props.noButton) {
      // console.log("[Dropdown] ==> hide");

      this.setState({ listVisible: false });
    }
  }

  renderSelectedIcon(item, isOnlyBool) {
    // console.log("[Dropdown] ==> renderSelectedIcon");

    // const isSelected = (this.state.selected && this.state.selected.id && parseInt(item.id, 10) == parseInt(this.state.selected.id, 10));
    // eslint-disable-next-line
    const isSelected =
      this.state.selectedId && this.state.selectedId === item.id;

    if (isOnlyBool) {
      return isSelected;
    } else {
      if (isSelected) {
        return <IconOk />;
      } else {
        return <div />;
      }
    }
  }

  renderListItems(propsItems) {
    // console.log("[Dropdown] ==> renderListItems");

    const items = [];

    for (let i = 0; i < propsItems.length; i++) {
      let item = propsItems[i];

      if (item) {
        const onClick = item.onClick ? item.onClick : this.props.onSelect;

        let elementClasses = "";

        switch (item.type) {
          case "hr":
            elementClasses = classNames(
              "dropdown-list--element",
              item.className
            );

            items.push(
              <li key={item.id || uuidv4()}>
                <HR className={elementClasses} />
              </li>
            );
            break;
          case "text":
            elementClasses = classNames(
              "dropdown-list--element",
              item.className
            );

            items.push(
              <li key={item.id || uuidv4()}>
                <P
                  className={elementClasses}
                  size={item.size}
                  mutted={item.mutted}
                >
                  {item.title}
                </P>
              </li>
            );
            break;
          case "as":
            let asElement;
            elementClasses = classNames(
              "button white-primary",
              "dropdown-list--element",
              {
                [`size-${item.size || this.props.listSize}`]:
                  item.size || this.props.listSize
              },
              item.className
            );

            const selectIcon = this.renderSelectedIcon(item, true) ? (
              <IconOk />
            ) : (
              <div />
            );

            if (item.onClick || item.onSelect) {
              asElement = React.createElement(
                item.as,
                {
                  to: item.link,
                  className: elementClasses,
                  onClick: () => this.handleSelectAs(item, onClick)
                },
                item.title,
                selectIcon
              );
            } else {
              asElement = React.createElement(
                item.as,
                {
                  to: item.link,
                  className: elementClasses
                },
                item.title
              );
            }

            items.push(<li key={item.id || uuidv4()}>{asElement}</li>);

            break;
          default:
            elementClasses = classNames(
              "dropdown-list--element",
              item.className
            );
            const themeButton =
              (item.button && item.button.theme) || "white-primary";
            const outlineButton = (item.button && item.button.outline) || false;

            items.push(
              <li key={item.id || uuidv4()}>
                <Button
                  theme={themeButton}
                  outline={outlineButton}
                  className={elementClasses}
                  onClick={() => this.handleSelect(item, onClick)}
                >
                  {item.title}

                  {this.renderSelectedIcon(item)}
                </Button>
              </li>
            );
        }
      }
    }

    return items;
  }

  render() {
    // console.log("[Dropdown] ==> render");

    const dropdownClasses = classNames(
      "dropdown",
      {
        show: this.state.listVisible
      },
      this.props.className
    );

    const dropdownContentClasses = classNames(
      "dropdown-content",
      {},
      this.props.classNameContent
    );

    const dropdownButtonClasses = classNames(
      "dropdown-button",
      {
        clicked: this.state.listVisible,
        select: this.props.type === "select",
        "dropdown-group": this.props.inGroup,
        /* Ошибка при валидации */
        error:
          this.props.type === "select" &&
          (this.props.isError ||
            (this.props.errors && this.props.errors.length))
      },
      this.props.classNameButton
    );

    const dropdownListClasses = classNames(
      "dropdown-list",
      {
        right: this.props.right,
        top: this.props.top,
        expanded: this.props.expanded
      },
      this.props.classNameList
    );

    const arrowDropdown = this.state.listVisible ? <IconTop /> : <IconDown />;

    /* NAME */
    const buttonSelectName = this.props.name || uuidv4();

    /* LABEL */
    let LabelElement = null;
    if (this.props.label) {
      LabelElement = React.createElement(
        "label",
        { htmlFor: buttonSelectName, className: "label" },
        this.props.label
      );
    }

    /* ERRORS */
    let errorsMessages = null;
    if (this.props.errors && this.props.errors.length) {
      errorsMessages = this.props.errors.map(error =>
        React.createElement(
          P,
          { size: "x-small", margin: "no", key: error },
          error
        )
      );
    }
    const errorClasses = classNames("input--errors", {
      /* Ошибка при валидации */
      error: this.props.errors && this.props.errors.length
    });
    const ErrorsElement = React.createElement(
      "div",
      { className: errorClasses },
      errorsMessages
    );

    /* BUTTON */
    let buttonDropdown = <div />;
    if (!this.props.noButton) {
      let descTitle = null;

      if (this.props.description) {
        descTitle = (
          <span>
            <br />
            <small>{this.props.description}</small>
          </span>
        );
      }

      buttonDropdown = (
        <Button
          name={buttonSelectName}
          theme={this.props.theme}
          className={dropdownButtonClasses}
          disabled={this.props.disabled}
          outline={this.props.outline}
          onClick={this.toogleShow}
          size={this.props.size}
          block={this.props.block}
          type={this.props.type === "select" ? "button" : this.props.type}
          tabIndex="0"
        >
          <span>{this.state.title}</span>
          {descTitle}

          {arrowDropdown}
        </Button>
      );
    }

    return (
      <div className={dropdownClasses}>
        {LabelElement}

        <div className={dropdownContentClasses}>
          {buttonDropdown}

          <ul className={dropdownListClasses}>
            {this.renderListItems(this.props.list)}
            {this.renderListItems(this.props.listAfter)}
          </ul>
        </div>

        {ErrorsElement}
      </div>
    );
  }
}

Dropdown.defaultProps = {
  name: null,
  type: "button",
  list: [],
  listAfter: [],
  listSize: "m",
  title: "",
  description: null,
  theme: null,
  outline: false,
  disabled: false,
  selected: null,
  selectedId: null,
  onSelect: null,
  right: false,
  top: false,
  size: null,
  label: null,
  block: null,
  errors: null,
  required: false,
  expanded: false,
  opened: false,
  noButton: false,
  inGroup: false,
  children: null
};

Dropdown.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  list: PropTypes.array,
  listAfter: PropTypes.array,
  listSize: PropTypes.oneOf(["s", "m", "l", "xl"]),
  title: PropTypes.string,
  description: PropTypes.string,
  theme: PropTypes.string,
  outline: PropTypes.bool,
  disabled: PropTypes.bool,
  selected: PropTypes.object,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  right: PropTypes.bool,
  top: PropTypes.bool,
  size: PropTypes.string,
  label: PropTypes.string,
  block: PropTypes.bool,
  required: PropTypes.bool,
  expanded: PropTypes.bool,
  opened: PropTypes.bool,
  noButton: PropTypes.bool,
  inGroup: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string)
};

export default onClickOutside(Dropdown);
